import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: flex-start;
  align-items: flex-start;

  ${theme.breakpoints.up("tablet")} {
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const SectionTitleLink = styled(EntityLink)`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
  white-space: nowrap;
`;

export const Dash = styled.span`
  margin-inline: 16px 8px;

  color: #000000;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const SubsectionLinks = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  inline-size: 100%;

  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 140%;

  overflow-x: auto;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SubsectionLink = styled(EntityLink)`
  color: #000000;
  white-space: nowrap;
`;
